// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1qYyw","dragIcon":"SortableItem_dragIcon__4d8ng","disabled":"SortableItem_disabled__6hxzs"};